import { Button, Modal, TextInput } from '@mantine/core';
import { useEffect, useState } from 'react';

import styles from './TextInputModal.module.scss';
import { Props } from './TextInputModal.types';

const TextInputModal = ({
  open,
  onClose,
  title,
  subtitle,
  placeholder,
  onValidate,
  loading,
  buttonText,
  defaultValue,
}: Props) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (open && defaultValue !== undefined) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  return (
    <Modal
      opened={open}
      onClose={onClose}
      title={<div className={styles.title}>{title}</div>}
      withCloseButton={true}
    >
      <div className={styles.container}>
        <p className={styles.subtitle}>{subtitle}</p>
        <form>
          <TextInput
            placeholder={placeholder}
            disabled={loading}
            value={value}
            onChange={event => setValue(event.target.value)}
          />

          <div className={styles.buttons}>
            <Button loading={loading} onClick={() => onValidate(value)}>
              {buttonText}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default TextInputModal;
